import { render, staticRenderFns } from "./CoDoorsNKeysMenu.vue?vue&type=template&id=eddb1dc6&scoped=true&"
import script from "./CoDoorsNKeysMenu.vue?vue&type=script&lang=js&"
export * from "./CoDoorsNKeysMenu.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=eddb1dc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddb1dc6",
  null
  
)

export default component.exports